import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-332aa11e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "headers",
  style: {"box-shadow":"none"}
}
const _hoisted_2 = { class: "containers head_desk" }
const _hoisted_3 = {
  key: 0,
  class: "logo"
}
const _hoisted_4 = {
  key: 0,
  class: "logopb",
  href: "https://www.policybazaar.com",
  "aria-label": "pb logo"
}
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 1,
  class: "claim-ratio"
}
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icons" }, null, -1))
const _hoisted_9 = {
  key: 2,
  class: "quotetop-rights"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "call_icon" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "phone_icon" }, "Call us", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "topIcon" }, null, -1))
const _hoisted_13 = { class: "d-flex flex-column" }
const _hoisted_14 = { class: "expertPopupInnerBody" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expertPopUpDetails pb-2 mb-2" }, [
  /*#__PURE__*/_createTextVNode(" You can reach us directly on the "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("below toll-free numbers ")
], -1))
const _hoisted_16 = { class: "expertPopUpBody" }
const _hoisted_17 = {
  key: 0,
  class: "expertPopUpDiv border-bottom-0 d-flex align-items-center mb-2"
}
const _hoisted_18 = /*#__PURE__*/_createStaticVNode("<div class=\"expertPopUpIcons d-flex justify-content-center align-items-center mr-2\" data-v-332aa11e><img alt=\"Term Insurance\" src=\"https://static.pbcdn.in/term-cdn/images/images/globalIcon.svg\" width=\"20\" height=\"20\" data-v-332aa11e></div><div class=\"expertPopUpIconsTxt\" data-v-332aa11e> For NRI’s <div class=\"expertPopUpCallingNumber\" data-v-332aa11e><a href=\"tel:+91 124-6656508\" data-v-332aa11e>+91 124-6656508</a></div></div>", 2)
const _hoisted_20 = [
  _hoisted_18
]
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"expertPopUpDiv d-flex align-items-center pb-2 mb-2\" data-v-332aa11e><div class=\"expertPopUpIcons d-flex justify-content-center align-items-center mr-2\" data-v-332aa11e><img alt=\"Term Insurance\" src=\"https://static.pbcdn.in/term-cdn/images/images/headSetIcon.svg\" width=\"20\" height=\"20\" data-v-332aa11e></div><div class=\"expertPopUpIconsTxt\" data-v-332aa11e> Looking To Buy ( Sales) <div class=\"expertPopUpCallingNumber\" data-v-332aa11e><a href=\"tel:1800-419-7713\" data-v-332aa11e>1800-419-7713</a></div></div></div><div class=\"expertPopUpDiv d-flex align-items-center pb-2 mb-2\" data-v-332aa11e><div class=\"expertPopUpIcons d-flex justify-content-center align-items-center mr-2\" data-v-332aa11e><img alt=\"Term Insurance\" src=\"https://static.pbcdn.in/term-cdn/images/images/telePhoneIcon.svg\" width=\"20\" height=\"20\" data-v-332aa11e></div><div class=\"expertPopUpIconsTxt\" data-v-332aa11e> Have Already Paid (Service) <div class=\"expertPopUpCallingNumber\" data-v-332aa11e><a href=\"tel:1800-258-5970\" data-v-332aa11e>1800-258-5970</a></div></div></div>", 2)
const _hoisted_23 = {
  key: 1,
  class: "expertPopUpDiv border-bottom-0 d-flex align-items-center mb-2"
}
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"expertPopUpIcons d-flex justify-content-center align-items-center mr-2\" data-v-332aa11e><img alt=\"Term Insurance\" src=\"https://static.pbcdn.in/term-cdn/images/images/globalIcon.svg\" width=\"20\" height=\"20\" data-v-332aa11e></div><div class=\"expertPopUpIconsTxt\" data-v-332aa11e> For NRI’s <div class=\"expertPopUpCallingNumber\" data-v-332aa11e><a href=\"tel:+91 124-6656508\" data-v-332aa11e>+91 124-6656508</a></div></div>", 2)
const _hoisted_26 = [
  _hoisted_24
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "expertPopUpBtmTxt text-center" }, [
  /*#__PURE__*/_createTextVNode(" Office Hours - 10:00 AM to 09:00 PM (IST) "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Use Registered No. Only* ")
], -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "logoimg",
    href: "https://www.policybazaar.com",
    "aria-label": "pb logo"
  })
], -1))
const _hoisted_29 = { class: "title" }
const _hoisted_30 = { class: "mobile_call" }
const _hoisted_31 = {
  key: 0,
  alt: "Term Insurance",
  src: "https://static.pbcdn.in/term-cdn/images/images/call_us_1.svg",
  width: "17",
  height: "16"
}
const _hoisted_32 = {
  key: 1,
  alt: "Term Insurance",
  src: "https://static.pbcdn.in/term-cdn/images/images/Call_icon.svg"
}
const _hoisted_33 = {
  key: 2,
  class: "txt"
}
const _hoisted_34 = {
  key: 3,
  class: "txt"
}
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<i class=\"topIcon\" data-v-332aa11e></i><div class=\"d-flex flex-column\" data-v-332aa11e><div class=\"expertPopupInnerBody\" data-v-332aa11e><div class=\"expertPopUpDetails pb-2 mb-2\" data-v-332aa11e> You can reach us directly on the <br data-v-332aa11e>below toll-free numbers </div><div class=\"expertPopUpBody\" data-v-332aa11e><div class=\"expertPopUpDiv d-flex align-items-center pb-2 mb-2\" data-v-332aa11e><div class=\"expertPopUpIcons d-flex justify-content-center align-items-center mr-2\" data-v-332aa11e><img alt=\"Term Insurance\" src=\"https://static.pbcdn.in/term-cdn/images/images/headSetIcon.svg\" width=\"20\" height=\"20\" data-v-332aa11e></div><div class=\"expertPopUpIconsTxt\" data-v-332aa11e> Looking To Buy ( Sales) <div class=\"expertPopUpCallingNumber\" data-v-332aa11e><a href=\"tel:1800-419-7713\" data-v-332aa11e>1800-419-7713</a></div></div></div><div class=\"expertPopUpDiv d-flex align-items-center pb-2 mb-2\" data-v-332aa11e><div class=\"expertPopUpIcons d-flex justify-content-center align-items-center mr-2\" data-v-332aa11e><img alt=\"Term Insurance\" src=\"https://static.pbcdn.in/term-cdn/images/images/telePhoneIcon.svg\" width=\"20\" height=\"20\" data-v-332aa11e></div><div class=\"expertPopUpIconsTxt\" data-v-332aa11e> Have Already Paid (Service) <div class=\"expertPopUpCallingNumber\" data-v-332aa11e><a href=\"tel:1800-258-5970\" data-v-332aa11e>1800-258-5970</a></div></div></div><div class=\"expertPopUpDiv border-bottom-0 d-flex align-items-center mb-2\" data-v-332aa11e><div class=\"expertPopUpIcons d-flex justify-content-center align-items-center mr-2\" data-v-332aa11e><img alt=\"Term Insurance\" src=\"https://static.pbcdn.in/term-cdn/images/images/globalIcon.svg\" width=\"20\" height=\"20\" data-v-332aa11e></div><div class=\"expertPopUpIconsTxt\" data-v-332aa11e> For NRI’s <div class=\"expertPopUpCallingNumber\" data-v-332aa11e><a href=\"tel:+91 124-6656508\" data-v-332aa11e>+91 124-6656508</a></div></div></div></div><div class=\"expertPopUpBtmTxt text-center\" data-v-332aa11e> Office Hours - 10:00 AM to 09:00 PM (IST) <br data-v-332aa11e>Use Registered No. Only* </div></div></div>", 2)
const _hoisted_37 = {
  key: 2,
  class: "header-mob spousehead"
}
const _hoisted_38 = { class: "heads" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { class: "logoimgs" }, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Spouse Term Insurance", -1))
const _hoisted_41 = { class: "mobile_call" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Term Insurance",
  width: "17",
  height: "16",
  src: "https://static.pbcdn.in/term-cdn/images/images/call-us.png"
}, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "txt" }, "Call us", -1))
const _hoisted_44 = /*#__PURE__*/_createStaticVNode("<span class=\"close\" data-v-332aa11e></span><i class=\"topIcon\" data-v-332aa11e></i><div class=\"d-flex flex-column\" data-v-332aa11e><div class=\"expertPopupInnerBody\" data-v-332aa11e><div class=\"expertPopUpDetails pb-2 mb-2\" data-v-332aa11e> You can reach us directly on the <br data-v-332aa11e>below toll-free numbers </div><div class=\"expertPopUpBody\" data-v-332aa11e><div class=\"expertPopUpDiv d-flex align-items-center pb-2 mb-2\" data-v-332aa11e><div class=\"expertPopUpIcons d-flex justify-content-center align-items-center mr-2\" data-v-332aa11e><img alt=\"Term Insurance\" src=\"https://static.pbcdn.in/term-cdn/images/images/headSetIcon.svg\" width=\"20\" height=\"20\" data-v-332aa11e></div><div class=\"expertPopUpIconsTxt\" data-v-332aa11e> Looking To Buy ( Sales) <div class=\"expertPopUpCallingNumber\" data-v-332aa11e><a href=\"tel:1800-419-7713\" data-v-332aa11e>1800-419-7713</a></div></div></div><div class=\"expertPopUpDiv d-flex align-items-center pb-2 mb-2\" data-v-332aa11e><div class=\"expertPopUpIcons d-flex justify-content-center align-items-center mr-2\" data-v-332aa11e><img alt=\"Term Insurance\" src=\"https://static.pbcdn.in/term-cdn/images/images/telePhoneIcon.svg\" width=\"20\" height=\"20\" data-v-332aa11e></div><div class=\"expertPopUpIconsTxt\" data-v-332aa11e> Have Already Paid (Service) <div class=\"expertPopUpCallingNumber\" data-v-332aa11e><a href=\"tel:1800-258-5970\" data-v-332aa11e>1800-258-5970</a></div></div></div><div class=\"expertPopUpDiv border-bottom-0 d-flex align-items-center mb-2\" data-v-332aa11e><div class=\"expertPopUpIcons d-flex justify-content-center align-items-center mr-2\" data-v-332aa11e><img alt=\"Term Insurance\" src=\"https://static.pbcdn.in/term-cdn/images/images/globalIcon.svg\" width=\"20\" height=\"20\" data-v-332aa11e></div><div class=\"expertPopUpIconsTxt\" data-v-332aa11e> For NRI’s <div class=\"expertPopUpCallingNumber\" data-v-332aa11e><a href=\"tel:+91 124-6656508\" data-v-332aa11e>+91 124-6656508</a></div></div></div></div><div class=\"expertPopUpBtmTxt text-center\" data-v-332aa11e> Office Hours - 10:00 AM to 09:00 PM (IST) <br data-v-332aa11e>Use Registered No. Only* </div></div></div>", 3)
const _hoisted_47 = [
  _hoisted_44
]
const _hoisted_48 = /*#__PURE__*/_createStaticVNode("<div class=\"spouse_img\" data-v-332aa11e><img alt=\"term\" src=\"https://static.pbcdn.in/term-cdn/images/vue/spouse_mobile.png\" data-v-332aa11e><div class=\"spouse_content_des\" data-v-332aa11e><p class=\"coverspouse\" data-v-332aa11e>Cover Your Spouse!</p><p data-v-332aa11e> Give extra security for <br data-v-332aa11e>your family’s future </p></div><div class=\"onlineIfo_section\" data-v-332aa11e><p class=\"online_discount\" data-v-332aa11e> Discount of <strong data-v-332aa11e> upto 10% <sup data-v-332aa11e>#</sup></strong></p><div class=\"covidInfo\" data-v-332aa11e>COVID-19 Covered</div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isMobiledevice())
      ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (!_ctx.isMobiledevice())
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (!_ctx.isposp)
                    ? (_openBlock(), _createElementBlock("a", _hoisted_4))
                    : _createCommentVNode("", true),
                  (_ctx.isposp)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "logopb",
                        href: `https://www.policybazaar.com${_ctx.utmSource ? ('?utm_source=' + _ctx.utmSource) : ''}`,
                        "aria-label": "pb logo"
                      }, null, 8, _hoisted_5))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isposp)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("a", {
                    target: "_blank",
                    rel: "noopener",
                    href: _ctx.getTermDecalLik
                  }, [
                    _hoisted_8,
                    _createTextVNode(" Claim assistance ")
                  ], 8, _hoisted_7)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isposp)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.openTalkToExp = true;}),
                    class: "pbcontact",
                    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openTalkToExp = false))
                  }, [
                    _hoisted_10,
                    _hoisted_11,
                    _createElementVNode("div", {
                      class: _normalizeClass(["talkExpertPopUpBody", {'show':_ctx.openTalkToExp}])
                    }, [
                      _hoisted_12,
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _hoisted_15,
                          _createElementVNode("div", _hoisted_16, [
                            (_ctx.isNri)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_20))
                              : _createCommentVNode("", true),
                            _hoisted_21,
                            (!_ctx.isNri)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
                              : _createCommentVNode("", true)
                          ]),
                          _hoisted_27
                        ])
                      ])
                    ], 2)
                  ], 32)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isSpouse)
      ? (_openBlock(), _createElementBlock("header", {
          key: 1,
          class: _normalizeClass(["header-mob", {'womenHeaader':_ctx.isWomen}])
        }, [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.isCrmLink?'Term of the day':'Term Insurance'), 1),
          _createElementVNode("div", {
            onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.openTalkToExp = true;}),
            class: "quotetop-rights"
          }, [
            _createElementVNode("em", _hoisted_30, [
              (_ctx.isWomen)
                ? (_openBlock(), _createElementBlock("img", _hoisted_31))
                : _createCommentVNode("", true),
              (!_ctx.isWomen)
                ? (_openBlock(), _createElementBlock("img", _hoisted_32))
                : _createCommentVNode("", true),
              (!_ctx.isWomen)
                ? (_openBlock(), _createElementBlock("span", _hoisted_33, "Call us"))
                : _createCommentVNode("", true),
              (_ctx.isWomen)
                ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Talk to Expert"))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["talkExpertPopUpBody", {'show' : _ctx.openTalkToExp }]),
                onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openTalkToExp = false))
              }, [
                _createElementVNode("span", {
                  class: "close",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeTalkToExp && _ctx.closeTalkToExp(...args)))
                }),
                _hoisted_35
              ], 34)
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.isSpouse)
      ? (_openBlock(), _createElementBlock("header", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _hoisted_39,
            _hoisted_40,
            _createElementVNode("div", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openTalktoExpertPopup && _ctx.openTalktoExpertPopup(...args))),
              class: "quotetop-rights"
            }, [
              _createElementVNode("em", _hoisted_41, [
                _hoisted_42,
                _hoisted_43,
                _createElementVNode("div", {
                  class: _normalizeClass(["talkExpertPopUpBody", {'show':_ctx.talkToExpertPopupOpen}])
                }, _hoisted_47, 2)
              ])
            ])
          ]),
          _hoisted_48
        ]))
      : _createCommentVNode("", true)
  ]))
}